import { render } from "./UpdateAccount.vue?vue&type=template&id=41ad8b7b"
import script from "./UpdateAccount.vue?vue&type=script&lang=js"
export * from "./UpdateAccount.vue?vue&type=script&lang=js"

import "./UpdateAccount.vue?vue&type=style&index=0&id=41ad8b7b&lang=css"
script.render = render

export default script